declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * Sends a GA4 event only when the gtag snippet is available.
 * Do not include names, email addresses, file names, or other personal data
 * in event properties.
 */
export function trackGaEvent(
  eventName: string,
  parameters: Record<string, unknown> = {}
) {
  window.gtag?.("event", eventName, parameters);
}
